import axios from 'axios';
import { ENDPOINTS } from '../constants';
import { IAvailableGame, ICreateTournamentRequest, ITournament } from '../types/ITournament';

export interface ITournamentsParams {
    active?: boolean;
}

interface ITournamentsResponse {
    total: number;
    entities: ITournament[];
}

export interface IUpdateTournamentChallengeRequest {
    tournamentId: number;
    challengeId: string;
    scheduledAt: string;
}

export const getTournaments = async (params: ITournamentsParams): Promise<ITournamentsResponse> => {
    const res = await axios.get(`${axios.defaults.baseURL}${ENDPOINTS.adminTournaments}`, { params });
    return res.data;
};

export const getTournament = async (id: number): Promise<ITournament> => {
    const res = await axios.get(`${axios.defaults.baseURL}${ENDPOINTS.tournament}/${id}`);
    return res.data;
};

export const getAvailableGames = async (): Promise<IAvailableGame[]> => {
    const res = await axios.get(`${axios.defaults.baseURL}${ENDPOINTS.availableGames}`);
    return res.data;
};

export const createTournament = async (data: ICreateTournamentRequest): Promise<void> => {
    await axios.post(`${axios.defaults.baseURL}${ENDPOINTS.adminTournaments}`, data);
};

export const deleteTournament = async (id: number): Promise<void> => {
    await axios.delete(`${axios.defaults.baseURL}${ENDPOINTS.adminTournaments}/${id}`);
};

export const publishTournament = async (id: number): Promise<void> => {
    await axios.post(`${axios.defaults.baseURL}${ENDPOINTS.adminTournaments}/${id}/publish`);
};

export const cancelTournament = async (id: number): Promise<void> => {
    await axios.post(`${axios.defaults.baseURL}${ENDPOINTS.adminTournaments}/${id}/cancel`);
};

export const pauseTournament = async (id: number): Promise<void> => {
    await axios.post(`${axios.defaults.baseURL}${ENDPOINTS.adminTournaments}/${id}/pause`);
};

export const resumeTournament = async (id: number): Promise<void> => {
    await axios.post(`${axios.defaults.baseURL}${ENDPOINTS.adminTournaments}/${id}/resume`);
};

export const updateTournamentChallenge = async ({
    tournamentId,
    challengeId,
    scheduledAt,
}: IUpdateTournamentChallengeRequest): Promise<void> => {
    await axios.put(`${axios.defaults.baseURL}${ENDPOINTS.adminTournaments}/${tournamentId}/challenges/${encodeURIComponent(challengeId)}`, {
        scheduledAt,
    });
};

export const getStatusColor = (status: string): { bg: string; text: string } => {
    const colorMap: Record<string, { bg: string; text: string }> = {
        Draft: { bg: '#2F313B', text: '#B4BCD0' },
        Registration: { bg: '#1E3A5F', text: '#4A90E2' },
        Active: { bg: '#1F4620', text: '#2ECC71' },
        Paused: { bg: '#4A3F1F', text: '#F39C12' },
        Completed: { bg: '#2D1B4E', text: '#9B59B6' },
        Cancelled: { bg: '#4A1F1F', text: '#E74C3C' },
        Archived: { bg: '#1F2A35', text: '#5D6D7B' },
    };
    return colorMap[status] || { bg: '#2F313B', text: '#B4BCD0' };
};
